<dialog #dialogElement [class]="{ backdrop: !hideActionButtons }">
  <div class="header" [class]="dialogType">
    <div class="icon" [ngSwitch]="dialogType" [hidden]="hideIcon">
      <svg
        *ngSwitchCase="'success'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 12C20.4477 12 20.0065 12.4495 19.9376 12.9974C19.7172 14.7514 18.9201 16.3936 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C12.5432 4 13.0762 4.05619 13.5917 4.16128C13.9705 4.23851 14.3696 4.14045 14.6429 3.86706C15.1796 3.33045 14.993 2.42582 14.2537 2.25471C13.5312 2.08751 12.7774 2 12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.85752 19.9997 6.95991 20.7362 8.17317 21.2388C9.38642 21.7413 10.6868 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.7096 17.4325 21.7208 15.2839 21.9501 12.9984C22.0052 12.4488 21.5523 12 21 12ZM8.62 10.79C8.22829 10.3983 7.59284 10.3994 7.20251 10.7925C6.81412 11.1836 6.81524 11.8152 7.205 12.205L10.785 15.785C10.9037 15.9037 11.0963 15.9037 11.215 15.785L20.295 6.70501C20.6848 6.31524 20.6859 5.68365 20.2975 5.29251C19.9072 4.89941 19.2717 4.89829 18.88 5.29L11 13.17L8.62 10.79Z"
        />
      </svg>
      <svg
        *ngSwitchCase="'info'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 8C11 8.55228 11.4477 9 12 9C12.5523 9 13 8.55228 13 8C13 7.44771 12.5523 7 12 7C11.4477 7 11 7.44771 11 8ZM11 17H13V11H11V17ZM11.99 22C6.47 22 2 17.52 2 12C2 6.48 6.47 2 11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22ZM12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4Z"
          fill="#0E71A3"
        />
      </svg>
      <svg
        *ngSwitchCase="'warning'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 5.99L19.53 19H4.47L12 5.99ZM12.4327 2.74741C12.2401 2.41477 11.7599 2.41477 11.5673 2.74741L1.43451 20.2495C1.24153 20.5828 1.48206 21 1.86722 21H22.1328C22.5179 21 22.7585 20.5828 22.5655 20.2495L12.4327 2.74741ZM13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17ZM13 10H11V14H13V10Z"
        />
      </svg>
      <svg
        *ngSwitchCase="'error'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16ZM12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4ZM12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7362 5.85752 19.9997 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34783 3.05357 6.8043 4.92893 4.92893C5.85752 4.00035 6.95991 3.26375 8.17317 2.7612C9.38642 2.25866 10.6868 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34783 22 12C22 13.3132 21.7413 14.6136 21.2388 15.8268C20.7362 17.0401 19.9997 18.1425 19.0711 19.0711C18.1425 19.9997 17.0401 20.7362 15.8268 21.2388C14.6136 21.7413 13.3132 22 12 22ZM11 7H13V13H11V7Z"
        />
      </svg>
    </div>
    <div class="title">
      <div class="text">{{ title }}</div>
    </div>
    <div
      class="close"
      title="Close {{ title }} dialog"
      [hidden]="hideCloseButton || !hideActionButtons"
      (click)="close()"
    >
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.295 7.66578C18.6844 7.27642 18.6844 6.64514 18.295 6.25578C17.9056 5.86642 17.2744 5.86642 16.885 6.25578L12 11.1408L7.115 6.25578C6.72564 5.86642 6.09436 5.86642 5.705 6.25578C5.31564 6.64514 5.31564 7.27642 5.705 7.66578L10.59 12.5508L5.705 17.4358C5.31564 17.8251 5.31564 18.4564 5.705 18.8458C6.09436 19.2351 6.72564 19.2351 7.115 18.8458L12 13.9608L16.885 18.8458C17.2744 19.2351 17.9056 19.2351 18.295 18.8458C18.6844 18.4564 18.6844 17.8251 18.295 17.4358L13.41 12.5508L18.295 7.66578Z"
          fill="black"
          fill-opacity="0.6"
        />
      </svg>
    </div>
  </div>
  <div class="content">
    <div
      class="content-text"
      *ngIf="contentText"
      [innerHTML]="contentText | safeHtml"
    ></div>
    <ng-container #contentContainer></ng-container>
  </div>
  <div class="actions" [hidden]="hideActionButtons">
    <div [hidden]="hideCancelButton" class="cancel-button" (click)="cancel()">
      <div>{{ cancelButtonText }}</div>
    </div>
    <div class="confirm-button" (click)="confirm()">
      <div>{{ confirmButtonText }}</div>
    </div>
  </div>
</dialog>
